module.exports = __webpack_public_path__ + "mr.svg?7d997a26191b4af48ef390510c3296a4";